import type {ISketchObject} from '../../../../../mesh/sketch';
import {SketchRelationKind} from '../../relation-compatibility/SketchRelationKinds';
import {MultiTargetRelation} from '../MultiTargetRelation';

let count = 0;

/**
 * 判断对象是否为线交点关系。
 * @param value 待判断对象。
 * @returns 是否为线交点关系。
 */
export function isLineIntersectionConstraint(value: object): value is LineIntersectionConstraint {
    return Reflect.get(value, 'isLineIntersectionConstraint') === true;
}

/**
 * 两条无限直线与焦点的交点关系定义。
 *
 * 交点位置由统一参数公式计算，本类不直接回写焦点。
 */
export class LineIntersectionConstraint extends MultiTargetRelation<ISketchObject> {
    /** 运行时类型标记。 */
    public readonly isLineIntersectionConstraint = true;
    /** 关系类型。 */
    public relationType = SketchRelationKind.Intersection;

    public constructor() {
        super();
        this.name = `${this.baseDisplayName}${count}`;
        count += 1;
    }

    /** 基础显示名。 */
    public get baseDisplayName(): string {
        return '交点';
    }
}
